<template>
  <div>
    <v-tabs v-if="lAction === 'view'" v-model="tab"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    >
    <v-tab :key="0" href="#tab-0">
      {{ tabitems[0] + ' (' + staff.length + ')' }}
    </v-tab>
    <v-tab :key="1" href="#tab-1">
      {{ tabitems[1] + ' (' + shifts.length + ')' }}
    </v-tab>
    <v-tab :key="2" href="#tab-2">
      {{ tabitems[2] + ' (' + roleList.length + ')' }}
    </v-tab>
    <v-tab :key="3" href="#tab-3">
      {{ tabitems[3] }}
    </v-tab>
  </v-tabs>
  <v-container class="pa-1">
    <v-layout row wrap>
      <v-flex xs12 mx-auto>
        <v-tabs-items v-if="lAction === 'view'" v-model="tab">
          <v-tab-item :key="0" value="tab-0">
            <v-layout class="pa-1" row wrap>
              <v-flex v-if="config.IS_BB_VENDOR" xs12 class="text-xs-center info pa-2 mb-2">
                <div class="white--text">
                  Sit back and relax, its <span class="accent--text">{{config.FM_VENDOR_NAME}}</span> managed community
                </div>
                <div class="accent--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">
                  We are proud to serve you
                </div>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-card-actions class="grey lighten-4 caption">
                      <v-layout row wrap>
                        <v-flex xs8>
                          <v-text-field
                          append-icon="search"
                          v-model="search"
                          class="pa-0 ml-1"
                          placeholder="Search name, role, etc..."
                          clearable
                          hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-download-as
                          :headers="staffHeadSm"
                          :items="staff"
                          title="Staff List"
                          ></v-download-as>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select
                          class="mt-0 ml-1 mr-1"
                          v-model="chosenVendor"
                          label="Vendor filter"
                          :items="staffVendors"
                          item-value="vendor_id"
                          item-text="vendor_name"
                          clearable
                          chips
                          multiple
                          hide-details
                          @input="loadStaffs"
                          ></v-select>
                        </v-flex>
                        <v-flex xs8 sm3>
                          <v-switch
                          class="mt-3 ml-1 mylable"
                          v-model="showAll"
                          label="Show past staffs as well"
                          @change="loadStaffs"
                          hide-details
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4 sm3 class="text-xs-right">
                          <v-btn small @click.stop="showQRCode(true)" class="mt-3"><v-icon class="pr-2">qr_code</v-icon>QR Code</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                    <v-card-text class="pa-0" >
                    <v-data-table
                    :headers="$vuetify.breakpoint.smAndUp?staffHeadSm:staffHead"
                    :items="staff"
                    hide-actions
                    class="elevation-2"
                    :search="search"
                    >
                    <template slot="items" slot-scope="props">
                      <tr @click="showStaff(props.item)" :class="props.item.type === 'VS' ? ((props.item.undeployed_on && props.item.undeployed_on < handy.formatDBDate(new Date())) ? 'grey--text' : 'info--text') : (props.item.undeployed_on ? 'grey--text' : '')">
                        <td>{{ props.item.staff_role }}</td>
                        <td>{{ props.item.vendor_emp_id ? props.item.vendor_emp_id : '-' }}</td>
                        <td>{{ props.item.staff_name }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.staff_mobile }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp && props.item.is_smart_attend" class="text-xs-center"><v-icon :color="props.item.is_ms_face_synched ? 'success' : 'warning'">check</v-icon><v-icon :color="props.item.is_fc_dev_synched ? 'success' : 'warning'">check</v-icon><v-icon v-if="props.item.is_sitevisit_attendance && config.IS_BACKOFFICE_COMM" :color="props.item.is_sitevisit_dev_synched ? 'success' : 'warning'">check</v-icon></td>
                        <td v-else-if="$vuetify.breakpoint.smAndUp" class="text-xs-center"><v-icon color="error">close</v-icon></td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.shift_abbr }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">
                          <v-icon color="green" v-if="props.item.is_billable === 1">check</v-icon>
                          <v-icon color="red" v-else>close</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-tab-item>

        <v-tab-item :key="1" value="tab-1">
          <v-layout class="pa-1">
            <v-flex xs12 md9 offset-sm3 class="mx-auto">
              <v-data-table
              :headers="$vuetify.breakpoint.smAndUp?shiftHeadSm:shiftHead"
              :items="shifts"
              hide-actions
              class="elevation-3"
              disable-initial-sort
              >
              <template slot="items" slot-scope="props">
                <tr @click="prepareUpdateShift(props.item)">
                  <td>{{ props.item.shift_abbr }}</td>
                  <td>{{ props.item.start_time }}</td>
                  <td>{{ props.item.end_time }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.shift_hours }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.break_start }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.break_end }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item :key="2" value="tab-2">
        <v-layout class="pa-1">
          <v-flex xs12 md9 offset-sm3 class="mx-auto">
            <v-data-table
            :headers="roleHead"
            :items="roleList"
            hide-actions
            class="elevation-3"
            disable-initial-sort
            >
            <template slot="items" slot-scope="props">
              <tr @click="prepareUpdateRole(props.item)">
                <td>{{ props.item.staff_role }}</td>
                <td>{{ props.item.role_cat }}</td>
                <td>{{ props.item.short_form }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-tab-item>

    <v-tab-item :key="3" value="tab-3" grid-list-md>
      <v-layout class="pa-1">
        <v-flex>
          <v-card>
            <v-card-title class="pa-2 grey lighten-4">
              <span class="title ml-2">Community Information</span>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
              :headers="commDetHead"
              :items="commDet"
              hide-actions
              dense
              disable-initial-sort
              >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.comm_name }}</td>
                  <td>{{ props.item.contact_email ? props.item.contact_email : '-' }}</td>
                  <td>{{ props.item.contact_phone ? props.item.contact_phone : '-' }}</td>
                  <td>{{ props.item.address ? props.item.address : '-' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout class="pa-1">
      <v-flex>
        <v-card>
          <v-card-title class="py-0 grey lighten-4">
            <span class="title">Active MC</span>
            <v-spacer></v-spacer>
            <v-btn small flat class="accent" @click="addMcDet()" >Add New</v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="mcHead"
            :items="mcList.filter(rec => rec.status === 'Active')"
            hide-actions
            dense
            disable-initial-sort
            >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.index + 1 }}</td>
                <td>{{ handy.formatDate(props.item.effective_from) }}</td>
                <td>{{ props.item.role_name }}</td>
                <td>{{ props.item.mc_name }}</td>
                <td>{{ props.item.contact_phone }}</td>
                <td>{{ props.item.personal_email_id }}</td>
                <td>{{ props.item.is_send_mail }}</td>
                <td class="layout">
                  <v-btn icon small class="mr-0"><v-icon small @click="prepareEditActive(props.item)">edit</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout class="pa-1">
    <v-flex>
      <v-card>
        <v-card-title class="py-2 grey lighten-4">
          <span class="title">In Active MC</span>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
          :headers="mcHead"
          :items="mcList.filter(rec => rec.status === 'In Active')"
          hide-actions
          dense
          disable-initial-sort
          >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.index + 1 }}</td>
              <td>{{ handy.formatDate(props.item.effective_from) }}</td>
              <td>{{ props.item.role_name }}</td>
              <td>{{ props.item.mc_name }}</td>
              <td>{{ props.item.contact_phone }}</td>
              <td>{{ props.item.personal_email_id }}</td>
              <td>{{ props.item.is_send_mail }}</td>
              <td class="layout">
                <v-btn icon small class="mr-0"><v-icon small @click="prepareEditInActive(props.item)">edit</v-icon></v-btn>
              </td>
            </tr>
          </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-tab-item>

<v-btn v-if="this.tab !== 'tab-3'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed
color="accent black--text"
@click.native="tab === 'tab-0' ? prepareCreate() : tab === 'tab-1' ? prepareCreateShift() : prepareCreateRole()">
<v-icon>add</v-icon>
</v-btn>
</v-tabs-items>

<!-- 1. create / edit  staff -->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-flex xs12 sm9 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction) }} Staff
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 v-if="config.IS_BB_VENDOR">
                  <v-alert v-if="lAction === 'create'" outline value="true" color="warning">
                    WARNING: Staffs employed by association or other vendor can be created here. <br /><br />{{config.FM_VENDOR_NAME}} staffs have to be created by {{config.FM_VENDOR_NAME}} HR in BackBone only.
                  </v-alert>
                  <v-alert v-else-if="lStaff.type === 'VS'" outline value="true" color="warning">
                    WARNING: Only role, shift and deployment dates can be updated here as this staff is employed by {{config.FM_VENDOR_NAME}}. <br /><br />Please contact {{config.FM_VENDOR_NAME}} HR to update any other details.
                  </v-alert>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :disabled="lStaff.type === 'VS'"
                  label="Name"
                  v-model="lStaff.staff_name"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="lStaff.staff_role_id"
                  label="Role"
                  :items="roleList"
                  item-value="staff_role_id"
                  item-text="staff_role"
                  :rules="[rules.required]"
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="lStaff.shift_id"
                  label="Shift"
                  :items="shifts"
                  item-value="shift_id"
                  item-text="shift_abbr"
                  :rules="[rules.required]"
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs10>
                  <v-combobox :disabled="lStaff.type === 'VS'"
                  v-model="lStaff.vendor"
                  label="Choose vendor"
                  :items= "config.IS_BB_VENDOR && lAction === 'create' ? allVendors.filter(rec => rec.vendor_id !== this.config.FM_VENDOR_ID) : allVendors"
                  item-value="vendor_id"
                  item-text="vendor_name"
                  maxlength="50"
                  clearable
                  hide-details
                  @input="validateVendor()"
                  ></v-combobox>
                </v-flex>
                <v-flex xs2>
                  <v-btn icon class="grey lighten-2 mt-2" :to="{path: '/vendor'}" ><v-icon>add</v-icon></v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-select :disabled="lStaff.type === 'VS'"
                  v-model="lStaff.staff_status"
                  label="Job status"
                  :items="['On Job', 'Resigned', 'Terminated']"
                  :rules="[rules.required]"
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="dlgDepDt"
                  persistent v-model="dlgDepDt"
                  lazy max-width="290px"
                  :return-value.sync="lStaff.deployed_on"
                  >
                  <v-text-field
                  slot="activator" label="Deployed Dt"
                  v-model="lStaff.deployed_on"
                  append-icon="event"
                  readonly clearable
                  hide-details
                  ></v-text-field>
                  <v-date-picker v-model="lStaff.deployed_on" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat @click="dlgDepDt = false">Cancel</v-btn>
                  <v-btn flat color="accent" @click="$refs.dlgDepDt.save(lStaff.deployed_on)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-dialog ref="dlgLastDt"
              persistent v-model="dlgLastDt"
              lazy max-width="290px"
              :return-value.sync="lStaff.undeployed_on"
              >
              <v-text-field
              slot="activator" label="Undeployed Dt"
              v-model="lStaff.undeployed_on"
              append-icon="event"
              readonly clearable
              hide-details
              ></v-text-field>
              <v-date-picker v-model="lStaff.undeployed_on" scrollable
              first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="dlgLastDt = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.dlgLastDt.save(lStaff.undeployed_on)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 v-if="lStaff.staff_status === 'Terminated'">
          <v-text-field
          label="Reason for termination"
          v-model="lStaff.term_reason"
          hide-details
          :rules="[rules.required]"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-checkbox
          v-model="lStaff.is_billable"
          label="Is Billable?"
          hide-details
          :disabled="lAction === 'create'"
          ></v-checkbox>
        </v-flex>
        <v-flex xs6 v-if="config.IS_BACKOFFICE_COMM">
          <v-checkbox
          v-model="lStaff.is_sitevisit_attendance"
          label="Site Visit Attendance"
          :hide-details="lStaff.is_smart_attend == 1"
          hint="Configure faces to enable this option"
          persistent-hint
          :disabled="lAction === 'create' || !lStaff.is_smart_attend"
          ></v-checkbox>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <span class="primary--text">Contact Information (optional)</span>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Mobile no."
          v-model="lStaff.staff_mobile"
          hide-details
          :rules="[rules.mobile]"
          maxlength="15"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Intercom no."
          v-model="lStaff.int_extn"
          hide-details
          maxlength="10"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Emergency contact"
          v-model="lStaff.emergency_contact"
          hide-details
          maxlength="50"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Emergency phone"
          v-model="lStaff.emergency_phone"
          hide-details
          maxlength="15"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <span class="primary--text">Other Information (optional)</span>
        </v-flex>
        <v-flex xs12>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Address"
          v-model="lStaff.staff_adr"
          hide-details
          maxlength="100"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="City"
          v-model="lStaff.city"
          hide-details
          maxlength="25"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="PIN"
          v-model="lStaff.pin_code"
          hide-details
          maxlength="10"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Blood group"
          v-model="lStaff.blood_group"
          hide-details
          maxlength="5"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field :disabled="lStaff.type === 'VS'"
          label="Known health issue"
          v-model="lStaff.known_health_issue"
          hide-details
          maxlength="50"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn @click.stop="cancelChanges">Cancel</v-btn>
      <v-btn type="submit" color="accent black--text" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-flex>
</v-card>
</v-form>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-container>

<!-- 1. create / edit  shift -->
<v-container v-if="lAction === 'create-shift' || lAction === 'update-shift'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="sForm" @submit.prevent="saveChangesShift(lAction)">
        <v-card flat>
          <v-flex xs12 sm9 md6 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction.substring(0, lAction.indexOf('-'))) }} Shift
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                  label="Shift Abbreviation"
                  v-model="lShift.shift_abbr"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="15"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-dialog
                  ref="shiftStart"
                  persistent
                  v-model="dlgShiftStart"
                  lazy
                  max-width="290px"
                  :return-value.sync="lShift.start_time"
                  >
                  <v-text-field
                  slot="activator"
                  label="Starts at"
                  v-model="lShift.start_time"
                  append-icon="access_time"
                  clearable
                  readonly
                  hide-details
                  :rules="[rules.required]"
                  ></v-text-field>
                  <v-time-picker v-model="lShift.start_time">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dlgShiftStart = false">Cancel</v-btn>
                    <v-btn flat color="accent" @click="$refs.shiftStart.save(lShift.start_time)">OK</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-dialog
                ref="shiftEnd"
                persistent
                v-model="dlgShiftEnd"
                lazy
                max-width="290px"
                :return-value.sync="lShift.end_time"
                >
                <v-text-field
                slot="activator"
                label="Ends at"
                v-model="lShift.end_time"
                append-icon="access_time"
                clearable
                readonly
                hide-details
                :rules="[rules.required]"
                ></v-text-field>
                <v-time-picker v-model="lShift.end_time">
                  <v-spacer></v-spacer>
                  <v-btn flat @click="dlgShiftEnd = false">Cancel</v-btn>
                  <v-btn flat color="accent" @click="$refs.shiftEnd.save(lShift.end_time)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              label="Shift Hours"
              v-model="lShift.shift_hours"
              :rules="[rules.required]"
              hide-details
              maxlength="5"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <div class="subheader mt-3 primary--text">
                Additional information (optional)
              </div>
            </v-flex>
            <v-flex xs6>
              <v-dialog
              ref="breakStart"
              persistent
              v-model="dlgBreakStart"
              lazy
              max-width="290px"
              :return-value.sync="lShift.break_start"
              >
              <v-text-field
              slot="activator"
              label="Break from"
              v-model="lShift.break_start"
              append-icon="access_time"
              clearable
              readonly
              hide-details
              ></v-text-field>
              <v-time-picker v-model="lShift.break_start">
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgBreakStart = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.breakStart.save(lShift.break_start)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog
            ref="breakEnd"
            persistent
            v-model="dlgBreakEnd"
            lazy
            max-width="290px"
            :return-value.sync="lShift.break_end"
            >
            <v-text-field
            slot="activator"
            label="Break till"
            v-model="lShift.break_end"
            append-icon="access_time"
            clearable
            readonly
            hide-details
            ></v-text-field>
            <v-time-picker v-model="lShift.break_end">
              <v-spacer></v-spacer>
              <v-btn flat @click="dlgBreakEnd = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.breakEnd.save(lShift.break_end)">OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn flat @click.stop="cancelChanges">Cancel</v-btn>
      <v-btn v-if="lAction === 'update-shift'" flat @click.stop="deleteShift">Delete</v-btn>
      <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-flex>
</v-card>
</v-form>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-container>

<!-- 2. create / edit  roles -->
<v-container v-if="lAction === 'create-role' || lAction === 'update-role'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="rForm" @submit.prevent="saveChangesRole(lAction)">
        <v-card flat>
          <v-flex xs12 sm9 md6 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction.substring(0, lAction.indexOf('-'))) }} Staff Role
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                  label="Category"
                  :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                  v-model="lRole.role_cat"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="20"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                  label="Role Name"
                  v-model="lRole.staff_role"
                  :rules="[rules.required]"
                  maxlength="50"
                  hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                  label="Short Form of Role Name"
                  v-model="lRole.short_form"
                  :rules="[rules.required]"
                  maxlength="8"
                  hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn flat @click.stop="cancelChanges">Cancel</v-btn>
              <v-btn flat v-if="lAction === 'update-role'" @click.stop="deleteRole">Delete</v-btn>
              <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>
      <v-divider></v-divider>
    </v-flex>
  </v-layout>
</v-container>

<v-dialog v-model="dlgStaff" max-width="400px">
  <v-card>
    <v-card-text class="pb-0 pl-2 pr-2">
      <div class="text-xs-center">
        <div class="headline">{{lStaff.staff_name}}</div>
        <div class="subheading">{{lStaff.staff_role}}</div>
        <div class="mt-2 info white--text subheading">
          <v-divider></v-divider>
          <div>{{lStaff.staff_status}} <span class="yellow--text">(Shift: {{lStaff.shift_abbr}})</span></div>
          <div>[{{handy.formatDate(lStaff.deployed_on)}} - {{(lStaff.undeployed_on ? handy.formatDate(lStaff.undeployed_on) : ' till date')}}]</div>
        </div>
      </div>
      <v-divider></v-divider>
      <v-container class="pa-0">
        <v-layout wrap>
          <v-flex xs12>
            <v-subheader class="primary--text subheader pl-0">Contact</v-subheader>
          </v-flex>
          <v-flex xs5 class="mb-2">
            <span class="grey--text">Mobile</span>
          </v-flex>
          <v-flex xs6>
            <span>{{lStaff.staff_mobile}}</span>
          </v-flex>
          <v-flex xs1>
            <v-btn v-if="false" icon small class="ma-0"><v-icon small>content_copy</v-icon></v-btn>
          </v-flex>
          <v-flex xs5 class="mb-2">
            <span class="grey--text">Emergency contact</span>
          </v-flex>
          <v-flex xs7>
            <span>{{lStaff.emergency_contact}}</span>
          </v-flex>
          <v-flex xs5 class="mb-2">
            <span class="grey--text">Emergency phone</span>
          </v-flex>
          <v-flex xs6>
            <span>{{lStaff.emergency_phone}}</span>
          </v-flex>
          <v-flex xs1>
            <v-btn v-if="false" icon small class="ma-0"><v-icon small>content_copy</v-icon></v-btn>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-divider></v-divider>
            <v-subheader class="primary--text pa-0">Smart Attendance</v-subheader>
            <div class="text-xs-center subheading">
              <div v-if="lStaff.is_smart_attend">
                <v-icon large :color="lStaff.is_ms_face_synched ? 'success' : 'warning'">check</v-icon>
                <v-icon large :color="lStaff.is_fc_dev_synched ? 'success' : 'warning'">check</v-icon>
                <v-icon large v-if="lStaff.is_sitevisit_attendance && config.IS_BACKOFFICE_COMM" :color="lStaff.is_sitevisit_dev_synched ? 'success' : 'warning'">check</v-icon>
                <br />
                Faces configured
                <div :class="'caption ' + (lStaff.is_ms_face_synched ? 'success--text' : 'warning--text')">
                  <span v-if="lStaff.is_ms_face_synched">In app attendance</span>
                  <span v-else>Face server not synched yet<span class="error-text">{{lStaff.ms_face_synch_err ? (' (' + lStaff.ms_face_synch_err + ')') : ''}}</span></span>
                </div>
                <div :class="'caption ' + (lStaff.is_fc_dev_synched ? 'success--text' : 'warning--text')">
                  <span v-if="lStaff.is_fc_dev_synched">FaceCheckin attendance</span>
                  <span v-else>{{'FaceCheckin device of this site not ' + (isFaceCheckinConfig ? 'synched yet' : 'configured')}}</span>
                </div>
                <div v-if="lStaff.is_sitevisit_attendance && config.IS_BACKOFFICE_COMM" :class="'caption ' + (lStaff.is_sitevisit_dev_synched ? 'success--text' : 'warning--text')">
                  <span v-if="lStaff.is_sitevisit_dev_synched">Site visit attendance</span>
                  <span v-else>{{'Other devices for site visit attendance not synched yet'}}<v-btn small icon class="ma-0" @click="showUnsyncDev()"><v-icon small>open_in_new</v-icon></v-btn></span>
                </div>
              </div>
              <div v-else>
                <v-icon large color="error">close</v-icon><br />
                Faces not configured yet
              </div>
              <v-btn :disabled="lStaff.undeployed_on && lStaff.undeployed_on < handy.formatDBDate(new Date())" small @click.stop="prepareFaceConfig(!lStaff.is_smart_attend)">{{Number(lStaff.is_smart_attend) ? 'View/Update Faces' : 'Configure Now'}}</v-btn>
              <v-btn v-if="lStaff.is_smart_attend" small @click.stop="showQRCode()"><v-icon class="pr-2">qr_code</v-icon>QR Code</v-btn>
            </div>
          </v-flex>
          <v-expansion-panel>
            <v-expansion-panel-content>
              <template slot="header">
                <div>More...</div>
              </template>
              <div class="pa-2">
                <v-flex xs12 class="mb-2">
                  <v-divider></v-divider>
                  <span class="primary--text subheader pl-0">Address</span>
                </v-flex>
                <v-flex xs11 class="mb-2 ml-2">
                  <div>{{lStaff.staff_adr}}</div>
                  <div>{{(lStaff.city ? lStaff.city : '') + (lStaff.pin ? ' - ' + lStaff.pin : '')}}</div>
                </v-flex>
                <v-flex xs12 class="mb-2">
                  <v-divider></v-divider>
                  <span class="primary--text subheader pl-0">Other info</span>
                </v-flex>
                <v-flex xs5 class="mb-2">
                  <span class="grey--text">Blood Group</span>
                </v-flex>
                <v-flex xs7>
                  <span>{{lStaff.blood_group}}</span>
                </v-flex>
                <v-flex xs5 class="mb-2">
                  <span class="grey--text">Health issue</span>
                </v-flex>
                <v-flex xs7>
                  <span>{{lStaff.known_health_issue}}</span>
                </v-flex>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="lStaff.type === 'CS'" flat @click.stop="deleteStaff">Delete</v-btn>
      <v-btn flat @click.stop="prepareUpdate">Update Staff</v-btn>
      <v-btn flat @click.native="dlgStaff=false" color="accent">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="dlgQRCode" max-width="800px" scrollable>
  <v-card flat>
    <v-card-text class="text-xs-center" ref="qrcode">
      <table>
        <tr v-for="(staffRow, i) in qrStaffList" :key="i">
          <td v-for="(staff, j) in staffRow" :key="j" style="padding:25px">
            <qrcode-vue v-if="staff.is_smart_attend" :value="staff.person_id + ''" size="135" level="H" render-as="svg"></qrcode-vue>
            <div style="text-align:center; font-size:125%" v-else>X</div>
            <div style="font-size:85%; padding-top:10px; text-align:center;">
              {{staff.staff_name.substring(0,20)}}
            </div>
          </td>
        </tr>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="dlgQRCode=false">close</v-btn>
      <v-btn flat @click="printQRCode"><v-icon class="pr-2">print</v-icon>Print</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="dlgFaceConfig" max-width="310px">
  <v-card>
    <v-card-title class="pa-0">
      <v-spacer></v-spacer>
      <v-btn small color="grey" icon @click.stop="closeFaceConfig"><v-icon small>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-0 pl-2 pr-2 pb-2 text-xs-center">
      <v-icon color="success" large v-if="faceProgress === 'Done'">check</v-icon>
      <v-icon large class="error--text" v-else-if="faceProgress.includes('Error')">close</v-icon>
      <div class="title mb-2">{{faceProgress}}</div>
      <div v-if="lStaff && lStaff.reg_faces && lStaff.reg_faces.filter(rec => rec.face_url).length < requiredFaces">
        <v-icon class="mt-0 mb-2">arrow_downward</v-icon>
        <video id="cam" style="width:280px; height:210px" autoplay></video>
        <div class="text-xs-center pb-1 pt-0">
          <v-btn icon @click="capturePhoto"><v-icon x-large>camera</v-icon></v-btn>
        </div>
      </div>
      <div v-else>
        <v-btn class="mt-0 mb-3" small @click="prepareFaceConfig()">Reconfigure</v-btn>
      </div>
      <v-layout row wrap>
        <v-flex xs4 v-for="(face, i) in lStaff.reg_faces" :key="i">
          <v-card class="ma-1" style="width:90px; height:90px">
            <div v-if="face.face_url">
              <img
              :src="face.face_url"
              height="89px"
              width="89px"
              ></img>
            </div>
            <div v-else class="title pa-2">
              {{i+1}}
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- create mc-->
<v-dialog v-model="showMcDet" persistent max-width="600px">
  <v-form ref="sForm" @submit.prevent="submitMcDet(lMAction)">
    <v-card flat>
      <v-card-title class="pa-3 title">
        Add Mc Detail
      </v-card-title>
      <v-card-text class="black--text pa-2">
        <v-container grid-list-md class="pa-2">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-dialog ref="effectFrom"
                persistent v-model="effectFrom"
                lazy max-width="290px"
                :return-value.sync="lMc.effective_from"
                >
                <v-text-field
                slot="activator" label="Effective from date"
                v-model="lMc.effective_from"
                append-icon="event"
                :rules="[rules.required]"
                readonly clearable
                hide-details
                required
                ></v-text-field>
                <v-date-picker v-model="lMc.effective_from" scrollable
                first-day-of-week="1"
                >
                <v-spacer></v-spacer>
                <v-btn flat @click="effectFrom = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.effectFrom.save(lMc.effective_from)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="effectTo"
            persistent v-model="effectTo"
            lazy max-width="290px"
            :return-value.sync="lMc.effective_to"
            >
            <v-text-field
            slot="activator" label="Effective to date"
            v-model="lMc.effective_to"
            append-icon="event"
            readonly clearable
            hide-details
            required
            ></v-text-field>
            <v-date-picker v-model="lMc.effective_to" scrollable
            first-day-of-week="1" :min="lMc.effective_from"
            >
            <v-spacer></v-spacer>
            <v-btn flat @click="effectTo = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.effectTo.save(lMc.effective_to)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-combobox
        v-model="lMc.role_pair"
        :items="rwaRoleList"
        label="Mc designation"
        item-value="role_id"
        item-text="role_name"
        :rules="[rules.required]"
        hide-details
        return-object
        ></v-combobox>
      </v-flex>
      <v-flex xs6>
        <v-text-field
        v-model="lMc.mc_name"
        label="MC name"
        :rules="[rules.required]"
        hide-details
        maxlength="100"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
        v-model="lMc.contact_phone"
        label="Contact phone"
        :rules="[rules.required]"
        hide-details
        maxlength="15"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
        v-model="lMc.personal_email_id"
        label="Personal email id"
        :rules="[rules.required]"
        hide-details
        maxlength="50"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-select
        v-model="lMc.is_send_mail"
        label="Can send mail?"
        :items="['Yes', 'No']"
        :rules="[rules.required]"
        hide-details
        maxlength="50"
        ></v-select>
      </v-flex>
      <v-flex xs6>
        <v-select
        v-model="lMc.status"
        label="Status"
        :items="['Active', 'In Active']"
        :rules="[rules.required]"
        hide-details
        maxlength="50"
        ></v-select>
      </v-flex>
    </v-layout>
  </v-flex>
</v-container>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn flat @click.stop="showMcDet = false">cancel</v-btn>
  <v-btn type="submit" flat color="accent" :disabled="beingSaved">submit</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-dialog>

<v-dialog v-model="dlgUnsyncDev" max-width="600px" scrollable>
  <v-card flat>
    <v-card-title class="grey lighten-4 title">
      Unsynched communities ({{unsynchDevList.length}})
    </v-card-title>
    <v-card-text>
      <v-data-table
      :headers="unsynchDevHd"
      :items="unsynchDevList"
      hide-actions
      >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.dev_list }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn flat @click="dlgUnsyncDev=false">close</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'
import QrcodeVue from 'qrcode.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs,
    QrcodeVue
  },
  data () {
    return {
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      search: '',
      // component specific
      tab: 'tab-0',
      tabitems: ['staff', 'shift', 'role', 'mc details'],
      lStaff: '',
      staff: [],
      showAll: false,
      chosenVendor: [],
      lShift: '',
      lRole: '',
      roleList: [],
      shifts: [],
      staffHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Emp ID', value: 'vendor_emp_id' },
        { text: 'Name', value: 'staff_name' }
      ],
      staffHeadSm: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Emp ID', value: 'vendor_emp_id' },
        { text: 'Name', value: 'staff_name' },
        { text: 'Mobile', value: 'staff_mobile' },
        { text: 'Smart Attendance?', value: 'is_smart_attend', align: 'center' },
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Billable?', value: 'is_billable', class: 'pa-0' }

      ],
      shiftHead: [
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Starts At', value: 'start_time' },
        { text: 'Ends At', value: 'end_time' }
      ],

      shiftHeadSm: [
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Starts At', value: 'start_time' },
        { text: 'Ends At', value: 'end_time' },
        { text: 'Shift Hours', value: 'shift_hours' },
        { text: 'Break From', value: 'break_start' },
        { text: 'Break Till', value: 'break_end' }
      ],
      roleHead: [
        { text: 'Staff Role', value: 'staff_role' },
        { text: 'Category', value: 'role_cat' },
        { text: 'Short Form', value: 'short_form' }
      ],
      dlgStaff: false,
      dlgShiftStart: false,
      dlgShiftEnd: false,
      dlgBreakStart: false,
      dlgBreakEnd: false,
      dlgDepDt: false,
      dlgLastDt: false,
      allVendors: [],
      staffVendors: [],
      dlgFaceConfig: false,
      requiredFaces: 3,
      faceProgress: '',
      faceProgText: ['1. Look STRAIGHT', '2. Slightly UP', '3. Slightly DOWN'],
      pagination: { rowsPerPage: 25 },
      isFaceCheckinConfig: false,
      dlgQRCode: false,
      qrStaffList: [],
      commDet: [],
      commDetHead: [
        { text: 'Community Name', value: 'comm_name' },
        { text: 'Contact Email', value: 'contact_email' },
        { text: 'Contact Phone', value: 'contact_phone' },
        { text: 'Address', value: 'address' }
      ],
      mcHead: [
        { text: 'Serial No', value: 's_no' },
        { text: 'Effective From', value: 'effective_from' },
        { text: 'Designation', value: 'role_name' },
        { text: 'Name', value: 'mc_name' },
        { text: 'Contact Phone', value: 'contact_phone' },
        { text: 'Personal Email Id', value: 'personal_email_id' },
        { text: 'Can Send Mail?', value: 'is_send_mail' },
        { text: 'Action', value: '' }
      ],
      mcList: [],
      rwaRoleList: [],
      lMc: {},
      lMAction: '',
      showMcDet: false,
      effectTo: false,
      effectFrom: false,
      showInActive: [],
      dlgUnsyncDev: false,
      unsynchDevList: [],
      unsynchDevHd: [
        { text: 'Community', value: 'comm_name' },
        { text: 'Device SNo.', value: 'dev_list' }
      ]
    }
  },
  created () {
    this.loadRoles()
    this.loadStaffs()
    this.loadShift()
    this.loadVendor()
    this.loadStaffVendor()
    this.checkIfAttendDevConfig()
    this.loadCommAddress()
    this.loadMcDet()
    this.loadRWARoles()
  },
  mounted () {
    // load staff and shifts list
    this.lAction = 'view'
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyStaff () {
      var emptyStaff = {
        type: 'CS',
        comm_id: config.COMM_ID,
        staff_name: '',
        staff_role_id: '',
        shift_id: '',
        staff_mobile: '',
        staff_status: 'On Job',
        term_reason: '',
        is_billable: false
      }
      return emptyStaff
    },
    showStaff (curStaff) {
      this.lStaff = Object.assign({}, curStaff)
      if (this.lStaff.vendor_id) {
        this.lStaff.vendor = this.allVendors.find(rec => rec.vendor_id === this.lStaff.vendor_id)
      }
      if (this.lStaff.deployed_on) {
        this.lStaff.deployed_on = handy.formatDBDate(this.lStaff.deployed_on)
      }
      if (this.lStaff.undeployed_on) {
        this.lStaff.undeployed_on = handy.formatDBDate(this.lStaff.undeployed_on)
      }
      this.lStaff.prev_is_sitevisit_attendance = this.lStaff.is_sitevisit_attendance
      this.dlgStaff = true
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    deleteStaff () {
      // confirm
      if (confirm('Sure, you want to delete the staff "' + this.lStaff.staff_name + '"?')) {
        // delete
        this.saveChanges('delete')
      }
    },
    prepareCreate () {
      this.lStaff = this.getEmptyStaff()
      this.lAction = 'create'
    },
    prepareUpdate () {
      this.dlgStaff = false
      this.lAction = 'update'
    },
    saveChanges (action) {
      // validate and save Changes
      if (action === 'create' || action === 'update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.validateVendor()) {
          return
        }
        if (!this.lStaff.deployed_on) {
          this.msg('Choose deployment date', true)
          return
        }
        if (this.lStaff.staff_status !== 'On Job' && !this.lStaff.undeployed_on) {
          this.msg('Choose undeployment date', true)
          return
        }
        if (this.lStaff.vendor) {
          this.lStaff.vendor_id = this.lStaff.vendor.vendor_id
        } else {
          this.lStaff.vendor_id = null
        }
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/staff/' + action, this.lStaff)
      .then(response => {
        // refresh list in front end
        this.lStaff.staff_role = this.roleList.find(rec => rec.staff_role_id === this.lStaff.staff_role_id).staff_role
        if (action === 'update' || action === 'delete') {
          var idx = this.staff.findIndex(obj => obj.staff_id === this.lStaff.staff_id)
          if (action === 'update') {
            // this.staff[idx] = this.lStaff
            // above code didn't refresh so I kept below code
            this.loadStaffs()
          } else { // delete
            this.staff.splice(idx, 1)
          }
        } else { // create
          this.loadStaffs()
        }
        this.loadStaffVendor() // staff may be associated to new vendor
        this.lAction = 'view'
        this.beingSaved = false
        this.dlgStaff = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    getEmptyShift () {
      var emptyShift = {
        comm_id: config.COMM_ID,
        shift_abbr: '',
        shift_hours: '',
        start_time: '',
        end_time: ''
      }
      return emptyShift
    },
    prepareCreateShift () {
      this.lShift = this.getEmptyShift()
      this.lAction = 'create-shift'
    },
    prepareUpdateShift (curShift) {
      this.lShift = Object.assign({}, curShift)
      this.lAction = 'update-shift'
    },
    deleteShift () {
      // confirm
      if (confirm('Sure, you want to delete the shift "' + this.lShift.shift_abbr + '"?')) {
        // delete
        this.saveChangesShift('delete-shift')
      }
    },
    saveChangesShift (action) {
      // validate and save Changes
      if (action === 'create-shift' || action === 'update-shift') {
        if (!this.$refs.sForm.validate()) {
          return
        }
        if (!this.lShift.start_time || !this.lShift.end_time) {
          this.msg('Choose shift start and end time', true)
          return
        }
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/shift/' + action, this.lShift)
      .then(response => {
        this.loadShift()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    getEmptyRole () {
      var emptyRole = {
        comm_id: config.COMM_ID,
        staff_role: ''
      }
      return emptyRole
    },
    prepareCreateRole () {
      this.lRole = this.getEmptyRole()
      this.lAction = 'create-role'
    },
    prepareUpdateRole (curRole) {
      this.lRole = Object.assign({}, curRole)
      this.lAction = 'update-role'
    },
    deleteRole () {
      // confirm
      if (confirm('Sure, you want to delete the role "' + this.lRole.staff_role + '"?')) {
        // delete
        this.saveChangesRole('delete-role')
      }
    },
    saveChangesRole (action) {
      // validate and save Changes
      if (action === 'create-role' || action === 'update-role') {
        if (!this.$refs.rForm.validate()) {
          return
        }
      }
      if (!this.lRole.short_form || !this.lRole.role_cat) {
        this.msg('Please enter category as well as its short form to show it in daily report', true)
      } else {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/role/' + action, this.lRole)
        .then(response => {
          this.loadRoles()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
    },
    prepareFaceConfig (capture = true) {
      this.dlgFaceConfig = true
      this.lStaff.reg_faces = []
      this.faceProgress = ''
      if (!capture) {
        // load faces from db
        var qry = {
          params: {
            source_type: 'staff',
            source_ref_id: this.lStaff.staff_id
          }
        }
        // list of available registered faces for this staff
        this.axios.get(config.API_URL + '/getRegisteredFaces/', qry)
        .then(response => {
          this.lStaff.reg_faces = response.data.map(rec => {
            rec.face_url = config.STATIC_FILES_DIR + rec.face_url
            return rec
          })
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err.response.data, true)
        })
      } else {
        // empty canvases to hold the face
        for (var i = 0; i < this.requiredFaces; i++) {
          this.lStaff.reg_faces.push({ 'face_url': null })
        }
        this.$forceUpdate()
        // prepare camera as there are no faces configured already
        this.prepareCamera()
        this.faceProgress = this.faceProgText[0] + ' & capture'
      }
    },
    prepareCamera () {
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome')
        return
      }
      // start camera and play
      this.chooseCamera()
    },
    chooseCamera () {
      navigator.mediaDevices.getUserMedia({video: {facingMode: 'environment'}})
      .then(stream => { // success
        document.querySelector('video').srcObject = stream
        this.localMediaStream = stream
      })
      .catch(error => {
        console.error('Webcam access is rejected: ' + error)
      })
    },
    capturePhoto () {
      const canvas = document.createElement('canvas')
      const video = document.querySelector('#cam')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      var curIdx = this.lStaff.reg_faces.filter(rec => rec.face_url).length
      this.lStaff.reg_faces[curIdx].face_url = canvas.toDataURL('image/png')
      this.$forceUpdate()
      // stop the camera if all photos are taken
      if (curIdx === this.requiredFaces - 1) {
        var tracks = this.localMediaStream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        this.localMediaStream.srcObject = null
        // save the changes in db
        this.faceProgress = 'Uploading photos...'
        var req = {
          comm_id: config.COMM_ID,
          source_type: 'staff',
          source_ref_id: this.lStaff.staff_id,
          reg_faces: this.lStaff.reg_faces,
          person_id: this.lStaff.person_id,
          is_smart_attend: this.lStaff.is_smart_attend,
          action: this.lStaff.is_smart_attend ? 'update' : 'create'
        }
        this.axios.post(config.API_URL + '/face-reg-staff/', req)
        .then(response => {
          this.faceProgress = 'Done'
          this.lStaff.person_id = response.data
          this.lStaff.is_smart_attend = 1
          this.lStaff.is_ms_face_synched = true
          this.lStaff.ms_face_synch_err = ''
          this.loadStaffs()
        })
        .catch(error => {
          this.lStaff.person_id = error.response.data.person_id
          this.faceProgress = 'Error:' + error.response.data.err
          this.lStaff.is_fc_dev_synched = false
          this.lStaff.is_ms_face_synched = false
        })
      } else {
        // get ready for next shot
        this.faceProgress = this.faceProgText[curIdx + 1] + ' & capture'
      }
    },
    closeFaceConfig () {
      // stop the camera if needed
      if (this.localMediaStream) {
        var tracks = this.localMediaStream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        this.localMediaStream.srcObject = null
      }
      this.dlgFaceConfig = false
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      // list of available roles
      this.axios.get(config.API_URL + '/getStaffRolesByCommId/', qry)
      .then(response => {
        this.roleList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.roleList = []
      })
    },
    loadStaffs () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          show_all: this.showAll,
          vendor_list: this.chosenVendor
        }
      }
      // list of staffs
      this.axios.get(config.API_URL + '/getStaffByCommId/', qry)
      .then(response => {
        this.staff = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.staff = []
      })
    },
    loadShift () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getShiftsByCommId/', qry)
      .then(response => {
        this.shifts = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.shifts = []
      })
    },
    loadVendor () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.allVendors = []
      this.axios.get(config.API_URL + '/getVendorByCommId/', qry)
      .then(response => {
        this.allVendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadStaffVendor () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.staffVendors = []
      this.axios.get(config.API_URL + '/getVendorWithStaffByCommId/', qry)
      .then(response => {
        this.staffVendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    validateVendor () {
      this.$forceUpdate()
      if (!this.lStaff.vendor || !this.lStaff.vendor.vendor_id) {
        this.msg('Choose a vendor', true)
        return false
      } else {
        return true
      }
    },
    checkIfAttendDevConfig () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.isFaceCheckinConfig = false
      this.axios.get(config.API_URL + '/getSmartDeviceByCommId/', qry)
      .then(response => {
        this.isFaceCheckinConfig = response.data.findIndex(rec => rec.smart_dev_type.indexOf('FaceCheckin') >= 0) >= 0
      })
    },
    showQRCode (all = false) {
      this.qrStaffList = []
      this.qrStaffList[0] = []
      if (all) {
        // create matrix 4 qr code in a row
        let idx = 0
        let j = 0
        for (let i = 1; i <= this.staff.length; i++) {
          this.qrStaffList[idx][j++] = this.staff[i - 1]
          if (i % 4 === 0) {
            ++idx
            this.qrStaffList[idx] = []
            j = 0
          }
        }
      } else {
        this.qrStaffList[0][0] = this.lStaff
      }
      this.dlgQRCode = true
    },
    printQRCode () {
      // print dialog
      var divContents = this.$refs.qrcode.innerHTML
      var a = window.open('', '', 'height:50; width:50')
      a.document.write('<html>')
      a.document.write('<head><title>QR Code - ' + config.COMM_NAME + ' - ' + (this.qrStaffList[0].length > 1 ? 'All staffs' : this.lStaff.staff_name) + '</title></head>')
      a.document.write('<body>')
      a.document.write(divContents)
      a.document.write('</body></html>')
      a.document.close()
      a.print()
    },
    loadCommAddress () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommAddress/', qry)
      .then(response => {
        this.commDet = response.data
        this.commDet.forEach(rec => {
          rec.comm_name = config.COMM_NAME
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.commDet = []
      })
    },
    addMcDet () {
      this.lMc = {
        effective_from: '',
        role_pair: {
          role_id: null,
          role_name: ''
        },
        mc_name: '',
        contact_phone: '',
        personal_email_id: '',
        is_send_mail: '',
        status: 'Active'
      }
      this.showMcDet = true
      this.lMAction = 'create'
    },
    submitMcDet (action) {
      if (this.lMc.status === 'In Active' && !this.lMc.effective_to) {
        this.msg('Please select effective to date', true)
        return
      }
      if (this.lMc.contact_phone.replace(/ +/g, '').length > 13) {
        this.msg('Please enter valid mobile number', true)
        return
      } else if (this.lMc.contact_phone.trim().startsWith('+')) {
        var temp = this.lMc.contact_phone.replace(/ +/g, '').substring(3, this.lMc.contact_phone.length)
        this.lMc.contact_phone = temp
      } else if (this.lMc.contact_phone) {
        this.lMc.contact_phone = this.lMc.contact_phone.replace(/ +/g, '')
      }
      this.beignSaved = true
      this.lMc.comm_id = config.COMM_ID
      this.lMc.role_id = this.lMc.role_pair.role_id
      this.axios.post(config.API_URL + '/McDet/' + action, this.lMc)
      .then(response => {
        this.loadMcDet(this.lMc)
        this.beingSaved = false
        this.showMcDet = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    loadMcDet () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.mcList = []
      this.axios.get(config.API_URL + '/getMcDet/', qry)
      .then(response => {
        this.mcList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.mcList = []
      })
    },
    loadRWARoles () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getRolesByRWA/', qry)
      .then(response => {
        this.rwaRoleList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.mcList = []
      })
    },
    prepareEditActive (curMcDet) {
      this.lMc = Object.assign({}, curMcDet)
      this.lMc.effective_from = this.lMc.effective_from ? handy.formatDBDate(this.lMc.effective_from) : null
      this.lMc.effective_to = this.lMc.effective_to ? handy.formatDBDate(this.lMc.effective_to) : null
      this.lMc.role_pair = { role_id: this.lMc.role_id, role_name: this.lMc.role_name }
      this.lMAction = 'edit'
      this.showMcDet = true
      this.loadRWARoles(curMcDet)
    },
    prepareEditInActive (curMcDet) {
      this.lMc = Object.assign({}, curMcDet)
      this.lMc.effective_from = this.lMc.effective_from ? handy.formatDBDate(this.lMc.effective_from) : null
      this.lMc.effective_to = this.lMc.effective_to ? handy.formatDBDate(this.lMc.effective_to) : null
      this.lMc.role_pair = { role_id: this.lMc.role_id, role_name: this.lMc.role_name }
      this.lMAction = 'edit'
      this.showMcDet = true
      this.loadRWARoles(curMcDet)
    },
    showUnsyncDev () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          staff_id: this.lStaff.staff_id
        }
      }
      this.unsynchDevList = []
      this.axios.get(config.API_URL + '/getUnsynchDevForSiteAttendance/', qry)
      .then(response => {
        this.unsynchDevList = response.data
        this.dlgUnsyncDev = true
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    }
  }
}
</script>

<style>
  .mylable{
    font-size:10px;
  }
</style>



// WEBPACK FOOTER //
// Staff.vue?b83d6282